import {Component, OnInit} from '@angular/core';
import {TypeUtils} from "../../../../../../../shared/utils/type-utils";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../../store';
import {ActivatedRoute} from "@angular/router";
import {distinctUntilChanged, filter, first, switchMap, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {DbResponse} from "../../../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../../../shared/components/notifier/notification-type";
import {CloudflareService} from "../../../../services/cloudflare.service";
import {FormControl, Validators} from "@angular/forms";
import {DbModalService} from "../../../../../../../modules/modal/modal";
import {VerifyHostnameComponent} from "../../../dialogs/verify-cloudflare-hostname/verify-hostname.component";
import {GoogleAnalyticsService} from "../../../../../../../shared/services/google-analytics/google-analytics.service";
import {Website} from "../../../../../website";
import {UserSubscription} from "../../../../../../../user/user-subscription";

@Component({
    selector: 'db-cdn-original-server',
    templateUrl: './cdn-original-server.component.html',
    styleUrls: ['./cdn-original-server.component.scss'],
    standalone: false
})
export class CdnOriginalServerComponent implements OnInit {
  public websiteId: number;
  public websiteUrl: string;
  public defaultRecord: any;
  public cfData: any;
  public loading: boolean;
  public userSubscription: UserSubscription;
  public originalRecord: FormControl;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  public initialDisabledBtn: boolean = true;

  constructor(
    private _route: ActivatedRoute,
    private _store: Store<fromStore.DbStoreState>,
    private _cloudflareService: CloudflareService,
    private _dbModalService: DbModalService,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit() {
    this.websiteId = +this._route.snapshot.parent.parent.params['id'];
    this._getUserSubscription();
    this._getCFData();
    this._getCFDefaultDnsRecord();
    this._getWebsiteUrl();
    // this._getCloudFlareOriginalRecordValue();
  }

  private _getUserSubscription(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserSubscription)),
        first()
      )
      .subscribe((userSubscription: UserSubscription) => {
        this.userSubscription = userSubscription;
      });
  }

  private _getCFData(): void {
    this._store.select(fromStore.getCloudflareData(this.websiteId))
      .pipe(
        distinctUntilChanged((cdnOldData: any, cdnNewData: any) => cdnOldData && cdnNewData && JSON.stringify(cdnOldData) === JSON.stringify(cdnNewData)),
        takeUntil(this._destroyStream$)
      )
      .subscribe(data => {
        if (!TypeUtils.isNull(data) && !TypeUtils.isEmpty(data)) {
          this.initialDisabledBtn = false;
          this.cfData = data;
          this.originalRecord = new FormControl(this.cfData.originalRecord, [Validators.required]);
        }
      });
  }

/*  private _getCloudFlareOriginalRecordValue(): void {
    this._store.select(fromStore.getCloudFlareOriginalRecordValue(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$),
      )
      .subscribe(state => {
        this.originalRecord = new FormControl(state, [Validators.required]);
        this.cfData.originalRecord = this.originalRecord;
      });
  }*/


  private _getCFDefaultDnsRecord(): void {
    this._store.select(fromStore.getCloudflareDefaultRecord(this.websiteId))
      .subscribe(data => {
        if (!TypeUtils.isNull(data) && !TypeUtils.isEmpty(data)) {
          this.defaultRecord = data;
        }
      });
  }

  public updateOriginalIp(): void {
    this.loading = true;
    this._cloudflareService.editDnsRecord(this.websiteId, this.originalRecord.value)
      .pipe(filter((response: DbResponse): boolean => !!response),
          first())
      .subscribe((response: DbResponse): void => {
        this.loading = false;
        if (response.success) {
          this.sendEvent('Update the original server IP');
          this._store.dispatch(new fromStore.SetClodFlareOriginalRecord(
            {
              websiteId: this.websiteId,
              originalRecord: this.originalRecord.value,
            }));
          NotifierComponent.notify(new Notification('Saved successfully', NotificationType.SUCCESS));
        }
        else {
          NotifierComponent.notify(new Notification('Something Went Wrong...', NotificationType.DANGER));
        }
      });
  }

  public showDnsRecords(): void {
    this.sendEvent('View DNS records button (settings)');
     const modal = this._dbModalService.open(VerifyHostnameComponent);
     modal.componentInstance.websiteId = this.websiteId;
     modal.componentInstance.websiteUrl = this.websiteUrl;
  }

  private _getWebsiteUrl(): void {
    this._store.select(fromStore.getWebsite(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$),
        filter(website => !!website)
      )
      .subscribe((website: Website) => {
        this.websiteUrl = website && website.site_url && website.site_url.replace(/(^\w+:|^)\/\//, '');
      });
  }

  public sendEvent(action: string): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: action,
      eventLabel: 'Cloudflare',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
